import React from "react";
import { Row, Col } from "react-bootstrap";
import MetricCard from "./MetricCard";

// Phase 5, §16. UAT pass rate is shown here for visibility, but is
// informational-only by default — never implied to be an employee's
// composite performance score.
export default function UatSummary({ uat }) {
  const u = uat || {};
  return (
    <Row className="g-3">
      <Col xs={6} md={3}><MetricCard label="UAT Submissions" value={u.uatSubmissions} direction="INFORMATIONAL_ONLY" icon="fa-vial" /></Col>
      <Col xs={6} md={3}><MetricCard label="Completion Rate" value={u.avgCompletionRate} isPercentage direction="HIGHER_IS_BETTER" icon="fa-gauge-high" insufficientData={!u.uatSubmissions} /></Col>
      <Col xs={6} md={3}>
        <MetricCard label="Pass Rate (Informational)" value={u.avgPassRate} isPercentage direction="INFORMATIONAL_ONLY" icon="fa-circle-check" insufficientData={!u.uatSubmissions} />
      </Col>
      <Col xs={6} md={3}><MetricCard label="Failed Cases" value={u.failedCases} direction="LOWER_IS_BETTER" icon="fa-triangle-exclamation" /></Col>
    </Row>
  );
}
